<template>
    <div>
        <div class="col-md-12">
            <div class="panel panel-visible">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-plus"></span>Добавить элемент схемы</div>
                </div>
                <form v-on:submit.prevent="add">
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-md-4">
                                <input type="text" v-model="forms.add.count" class="form-control" placeholder="Количество человек в группе">
                                <div v-if="$v.forms.add.count.$error === true" class="error">
                                    Заполните поле
                                </div>
                            </div>
                            <div class="col-md-4">
                                <input type="text" v-model="forms.add.before_18" class="form-control" placeholder="Выплата до 18:00">
                                <div v-if="$v.forms.add.before_18.$error === true" class="error">
                                    Заполните поле
                                </div>
                            </div>
                            <div class="col-md-4">
                                <input type="text" v-model="forms.add.after_18" class="form-control" placeholder="Выплата после 18:00">
                                <div v-if="$v.forms.add.after_18.$error === true" class="error">
                                    Заполните поле
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <input type="submit" class="btn btn-primary" value="Добавить">
                    </div>
                </form>
            </div>
        </div>
        <div class="col-md-12">
            <div class="panel panel-visible" id="spy2">

                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-tasks"></span>Схемы оплат</div>
                </div>
                <div class="panel-body pn">
                    <table class="table table-striped table-hover datatables" cellspacing="0" width="100%">
                        <thead>
                        <tr>
                            <th>Количество человек</th>
                            <th>Сумма до 18:00</th>
                            <th>Сумма после 18:00</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(count, index) in salaryScheme.counts" v-bind:key="index">
                            <td>{{count.count}}</td>
                            <td>{{count.before_18}}</td>
                            <td>{{count.after_18}}</td>
                            <td>
                                <drop-down-button name="Действие" classes="btn-info btn-sm">
                                    <li>
                                        <a v-on:click="remove(index)">
                                            Удалить
                                        </a>
                                    </li>
                                </drop-down-button>
                            </td>
                        </tr>
                        <tr v-if="salaryScheme.counts.length === 0">
                            <td colspan="4" class="text-center">Нет записей</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DirectionSalaryScheme from "../../models/DirectionSalaryScheme";
    import { required } from 'vuelidate/lib/validators';
    import {validationMixin} from "vuelidate";

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            let salarySchemeResponse = await DirectionSalaryScheme.get(to.params.id);
            next(component => {
                component.salaryScheme = salarySchemeResponse;
            });
        },
        components: {
            Loading: () => import('vue-loading-overlay'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        data() {
            return {
                isLoading: false,
                forms: {
                    add: {
                        count: '',
                        before_18: '',
                        after_18: '',
                    },
                },
                salaryScheme: new DirectionSalaryScheme({
                    name: '',
                    counts: [],
                }),
            };
        },
        validations: {
            forms: {
                add: {
                    count: {required},
                    before_18: {required},
                    after_18: {required},
                },
            },
        },
        methods: {
            async update() {
                this.isLoading = true;
                await this.salaryScheme.update();
                this.isLoading = false;
            },
            add() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.salaryScheme.counts.push({
                    count: this.forms.add.count,
                    before_18: this.forms.add.before_18,
                    after_18: this.forms.add.after_18,
                });

                this.update();
            },

            remove(index) {
                this.salaryScheme.counts.splice(index, 1);
                this.update();
            }
        },
        metaInfo() {
            return {
                title: 'Схемы выплат - редактирование',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>